
import ColorVersionConfirmed from "../../../../server/com/silkplm/dashlets/ColorVersionConfirmed.js";
import ColorVersionOrdered from "../../../../server/com/silkplm/dashlets/ColorVersionOrdered.js";
import DashboardsGeneral from "../../../../server/com/silkplm/dashlets/DashboardsGeneral.js";
import ProjectsWithSamples from "../../../../server/com/silkplm/dashlets/ProjectsWithSamples.js";
import StackedBarChart from "../../../../server/com/silkplm/dashlets/StackedBarChart.js";
import UnreadMessages from "../../../../server/com/silkplm/dashlets/UnreadMessages.js";
import UnreadMessagesDashletForInquiry from "../../../../server/com/silkplm/dashlets/UnreadMessagesDashletForInquiry.js";
import UnreadMessagesDashletForOffers from "../../../../server/com/silkplm/dashlets/UnreadMessagesDashletForOffers.js";
import UnreadMessagesDashletForPPSample from "../../../../server/com/silkplm/dashlets/UnreadMessagesDashletForPPSample.js";
import UnreadMessagesDashletForSample from "../../../../server/com/silkplm/dashlets/UnreadMessagesDashletForSample.js";

class Dashlets{
    constructor() {

            /** @type {module:src/server/com/silkplm/dashlets/ColorVersionConfirmed.ColorVersionConfirmed} */
            this.ColorVersionConfirmed = new ColorVersionConfirmed();
            /** @type {module:src/server/com/silkplm/dashlets/ColorVersionOrdered.ColorVersionOrdered} */
            this.ColorVersionOrdered = new ColorVersionOrdered();
            /** @type {module:src/server/com/silkplm/dashlets/DashboardsGeneral.DashboardsGeneral} */
            this.DashboardsGeneral = new DashboardsGeneral();
            /** @type {module:src/server/com/silkplm/dashlets/ProjectsWithSamples.ProjectsWithSamples} */
            this.ProjectsWithSamples = new ProjectsWithSamples();
            /** @type {module:src/server/com/silkplm/dashlets/StackedBarChart.StackedBarChart} */
            this.StackedBarChart = new StackedBarChart();
            /** @type {module:src/server/com/silkplm/dashlets/UnreadMessages.UnreadMessages} */
            this.UnreadMessages = new UnreadMessages();
            /** @type {module:src/server/com/silkplm/dashlets/UnreadMessagesDashletForInquiry.UnreadMessagesDashletForInquiry} */
            this.UnreadMessagesDashletForInquiry = new UnreadMessagesDashletForInquiry();
            /** @type {module:src/server/com/silkplm/dashlets/UnreadMessagesDashletForOffers.UnreadMessagesDashletForOffers} */
            this.UnreadMessagesDashletForOffers = new UnreadMessagesDashletForOffers();
            /** @type {module:src/server/com/silkplm/dashlets/UnreadMessagesDashletForPPSample.UnreadMessagesDashletForPPSample} */
            this.UnreadMessagesDashletForPPSample = new UnreadMessagesDashletForPPSample();
            /** @type {module:src/server/com/silkplm/dashlets/UnreadMessagesDashletForSample.UnreadMessagesDashletForSample} */
            this.UnreadMessagesDashletForSample = new UnreadMessagesDashletForSample();
    }
}

export default Dashlets;

